import { ibanNormalizeFunction } from "@/utils/formUtils";
import { ALL_WHITE_SPACES_PATTERN, tryToExtractBankNameFromIban } from "@/utils/utils";
import { validations } from "@/utils/validationUtils";
import { Col, Divider, Form, Input, Row } from "antd";
import { useTranslation } from "react-i18next";
import ActionButton from "../../../../../../common/components/buttons/ActionButton";
import DeleteIcon from "../../../../../../common/components/icons/DeleteIcon";
import { rowGutter } from "../../../../../../common/constants";
import { CreateCalcSettings, UpdateCalcSettings } from "../../../types";

export const CalcSettingsPaymentDetailsPart = () => {
  const { t } = useTranslation();

  const form = Form.useFormInstance<CreateCalcSettings | UpdateCalcSettings>();
  const bankAccounts = Form.useWatch(["paymentDetails", "bankAccounts"], form);

  return (
    <>
      <Divider titlePlacement="start">{t("calc.settings.attrs.paymentDetails._label")}</Divider>

      <Row gutter={rowGutter}>
        <Col span={5}>
          <Form.Item
            name={["paymentDetails", "constantSymbol"]}
            label={t("calc.settings.attrs.paymentDetails.constantSymbol")}
            rules={[validations.numeric, validations.length(4)]}
          >
            <Input maxLength={4} />
          </Form.Item>
        </Col>
      </Row>

      <Form.List name={["paymentDetails", "bankAccounts"]} initialValue={[""]}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, ...field }) => (
              <Row gutter={rowGutter} key={key}>
                <Col span={6}>
                  <Form.Item
                    {...field}
                    name={field.name}
                    label={t("calc.settings.attrs.paymentDetails.bankAccount")}
                    rules={[validations.notBlank, validations.iban]}
                    getValueProps={(value) => ({ value: value ? ibanNormalizeFunction(value) : value })}
                    normalize={(value) => value?.replace(ALL_WHITE_SPACES_PATTERN, "")}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={9} style={{ marginTop: 34 }}>
                  {tryToExtractBankNameFromIban(bankAccounts?.[field.name])}
                </Col>

                {fields.length > 1 && (
                  <Col span={1}>
                    <DeleteIcon onClick={() => remove(field.name)} />
                  </Col>
                )}
              </Row>
            ))}

            <ActionButton icon="plus" onClick={() => add()}>
              {t("calc.settings.actions.addBankAccount")}
            </ActionButton>
          </>
        )}
      </Form.List>
    </>
  );
};
